'use strict';

/**
 * Importing CSS
 */
import 'c3/c3.css';

/**
 * Importing 3rd Party libs and modules
 */
import angular from 'angular';
import 'c3-angular/c3-angular.min';
import ngFileUpload from 'ng-file-upload';
import categoriesController from './categories.controller';
import categoriesService from './categories.service';
/**
 * Importing Controllers, Service, Factories
 */

export default angular.module('ornamentUser',
	[ngFileUpload])
	.service('categoriesService',categoriesService)
	.config(['$stateProvider', function($stateProvider){
		$stateProvider
			.state('app.categories', {
				url:'/uploads',
				template:require('./categories.html'),
				controller:categoriesController,
				controllerAs:'vm'
			});
	}])
	.name;


// WEBPACK FOOTER //
// ./src/app/modules/categories/index.js